import { useEffect, useRef } from "react";
import { registerTiming } from "server/Statistics/Requests";

const INACTIVITY_TIMEOUT = 5 * 60 * 1000;

const UserActivityTracker = () => {
  const sessionStart = useRef<Date>(new Date());
  const lastActivity = useRef<number>(Date.now());

  useEffect(() => {
    const resetTimer = () => {
      lastActivity.current = Date.now();
    };

    const sendTimeSpent = async () => {
      if (!sessionStart) return;

      const sessionEnd = new Date();
      try {
        const response = await registerTiming({
          startDate: sessionStart.current.toISOString(),
          endDate: sessionEnd.toISOString(),
        });

        if (response.status === 200) {
          console.log("Temps enregistré avec succès");
        } else {
          console.error("Erreur lors de l'enregistrement du temps");
        }
      } catch (error) {
        console.error("Échec de la requête :", error);
      }
    };

    const checkInactivity = () => {
      if (Date.now() - lastActivity.current > INACTIVITY_TIMEOUT) {
        console.log("Utilisateur inactif. Envoi des données...");
        sendTimeSpent();
        sessionStart.current = new Date();
      }
    };

    const handleVisibilityChange = () => {
      if (document.hidden) {
        console.log("Onglet masqué. Envoi des données...");
        sendTimeSpent();
      } else {
        console.log("Onglet actif. Reprise du tracking.");
        sessionStart.current = new Date();
        lastActivity.current = Date.now();
      }
    };

    const events = ["mousemove", "keydown", "click", "scroll"];
    events.forEach((event) => window.addEventListener(event, resetTimer));

    const interval = setInterval(checkInactivity, 60 * 1000);
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      events.forEach((event) => window.removeEventListener(event, resetTimer));
      clearInterval(interval);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      sendTimeSpent();
    };
  }, []);

  return null;
};

export default UserActivityTracker;
